import { useTranslations } from '@aikoa/i18n/react'
import { EditNotesSheet } from '~/components/notes/EditNotesSheet'
import { type ButtonSize, type ButtonVariant } from '~/components/ui/button'
import { useUpdateAsset } from '~/data/assets/useAssets'
import { queryClient, trpc } from '~/lib/trpc'

type EditNotesInlineProps = {
  assetId: string
  currentNotes?: string
  onSuccess?: () => void
  className?: string
  triggerClassName?: string
  triggerVariant?: ButtonVariant
  triggerSize?: ButtonSize
  triggerLabel?: string
}

export function EditNotesInline({
  assetId,
  currentNotes,
  onSuccess,
  className,
  triggerClassName,
  triggerVariant = 'outline',
  triggerSize = 'default',
  triggerLabel,
}: EditNotesInlineProps) {
  const { t } = useTranslations(['property', 'common'])
  const { mutate: updateAsset, isPending } = useUpdateAsset()

  const defaultTriggerLabel = t(($) => $.actions.edit)

  const handleSave = (notes: string) => {
    updateAsset(
      {
        assetId,
        assetPayload: {
          relationData: {
            notes,
          },
        },
      },
      {
        onSuccess: () => {
          void queryClient.invalidateQueries({
            queryKey: trpc.property.getAssetDetails.queryKey({
              assetId,
            }),
          })
          onSuccess?.()
        },
      }
    )
  }

  return (
    <EditNotesSheet
      modalKey={`edit-notes-${assetId}`}
      currentNotes={currentNotes}
      onSave={handleSave}
      isPending={isPending}
      className={className}
      triggerClassName={triggerClassName}
      triggerVariant={triggerVariant}
      triggerSize={triggerSize}
      triggerLabel={triggerLabel ?? defaultTriggerLabel}
      placeholder={t(($) => $.notes.placeholder)}
    />
  )
}
